import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { createStyles } from 'utils/createStyle';

export const styles = createStyles({
    radioList: ['flex flex-col space-y-5', { width: '280px' }],
    radioOption: [
        'flex items-center text-lg py-1 px-5 bg-white border border-grey-light rounded-full',
        { height: '72px' },
    ],
    radioOptionSelected: [
        'flex items-center text-lg py-1 px-5 bg-white border-2 border-brand rounded-full',
        { height: '72px' },
    ],
    checkIcon: ['text-brand', { fontSize: '32px', width: '32px', height: '32px' }],
    unselectedCircle: [
        'text-grey-2 rounded-full border-2 border-grey-light',
        { width: '32px', height: '32px' },
    ],
    optionLabel: 'm-4 ml-3 text-grey-medium',
    optionLabelSelected: 'm-4 ml-3 text-grey-darkest font-semibold',
});

interface CustomRadioSelectorProps {
    options: string[];
    onSelectionChange: (selectedValue: string) => void;
    value: string;
}

export const CustomRadioSelector = ({
    options,
    value,
    onSelectionChange,
}: CustomRadioSelectorProps) => {
    // const [selectedValue, setSelectedValue] = useState<string>('');

    // useEffect(() => {
    //     if (options.length > 0) {
    //         setSelectedValue(options.find((option) => option === value) || options[0]);
    //     }
    // }, [value]);

    // const handleSelection = (value: string) => {
    //     setSelectedValue(value);
    //     onSelectionChange(value);
    // };

    return (
        <div className={styles.radioList}>
            {options.map((option, index) => (
                <button
                    key={index}
                    className={value === option ? styles.radioOptionSelected : styles.radioOption}
                    onClick={() => onSelectionChange(option)}
                >
                    {value === option ? (
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkIcon} />
                    ) : (
                        <div className={styles.unselectedCircle} />
                    )}
                    <span
                        className={
                            value === option ? styles.optionLabelSelected : styles.optionLabel
                        }
                    >
                        {option}
                    </span>
                </button>
            ))}
        </div>
    );
};
export default CustomRadioSelector;
